module.exports = __webpack_public_path__ + "img/Protect_your_account_Light.f66dd371.svg";